import React, {forwardRef,} from 'react'
import {Elevation} from '../styles/elevation'
import RaisedButton, {} from './RaisedButton'



const FloatingActionButton = forwardRef((props, ref) => {
  return (
    React.createElement(RaisedButton, {
      ...props,
      className: props.className,
      elevationHovered: Elevation.Z12,
      elevationResting: Elevation.Z6,
      elevationPressed: Elevation.Z9,
      ref: ref,}

      , props.children
    )
  )
})

export default FloatingActionButton
